import { PERPAGE_DEFAULT_SM } from "app_config";
import { objectSerializer } from "./utils";
import { calPaginatorRecord } from "./paginator";
import { toast } from "react-toastify";

const createInitialState = () => ({
  data: [],
  totalRows: 0,
  totalPagesCount: 0,
  currentPage: 1,
  pageSize: PERPAGE_DEFAULT_SM,
  fromRecord: 0,
  toRecord: 1,
  currentParams: { page: 1, per_page: PERPAGE_DEFAULT_SM },
  filterTags: [],
  selectedRecord: []
});

const initialState = {
  allData: createInitialState(),
  activityLogData: createInitialState(),
  loading: false,
  exporting: false,
  sortParams: {attribute: 'id', direction: 'desc'},
  sortColumns: {},
  recordData: {},
  summaryData: {}
}

const initialStateStatus = {
  allData: createInitialState(),
  submitedData: createInitialState(),
  waitingApprovalData: createInitialState(),
  approvedData: createInitialState(),
  rejectedData: createInitialState(),
  canceledData: createInitialState(),
  activityLogData: createInitialState(),
  loading: false,
  exporting: false,
  sortParams: {attribute: 'id', direction: 'desc'},
  sortColumns: {},
  recordData: {}
}

const handleFulfilled = (state, action, dataKey) => {
  state.loading = false;
  const results = action.payload || {};
  const data = state[dataKey];

  if (!data) return;

  const rows = Array.isArray(results.rows) ? results.rows : [];

  data.data = objectSerializer(rows) || [];
  data.totalRows = Number.isFinite(results.total_rows) ? results.total_rows : 0;

  const calRecords = calPaginatorRecord(data.currentPage, data.pageSize, data.totalRows);
  data.totalPagesCount = calRecords.totalPagesCount;
  data.fromRecord = calRecords.beginRecords || 1;
  data.toRecord = calRecords.lastRecords;

  if (results && results.summary) {
    data.summary = results.summary;  // ✅ Lưu vào "summary" để match component
    state.summaryData = results.summary;
  }
};

/**
 * `silent` keeps the store update but drops the success toast, for actions whose
 * component already reports the outcome itself — otherwise the user gets two
 * toasts for one click, and the server's wording wins the argument.
 */
const handlePayload = (state, action, type="none", { silent = false } = {}) => {
  const { error, data, message, isAccessDenied, accessDeniedPageShown } = action.payload;

  if (error !== undefined) {
    // Màn hình 403 đã hiển thị cho request này → không bắn thêm toast.
    if (accessDeniedPageShown) return;

    // 403 errors: deduplicate via toastId so only one toast shows even when
    // multiple concurrent API calls fail on the same page.
    if (isAccessDenied) {
      toast.error(error, { toastId: 'http_403' });
    } else {
      toast.error(error);
    }
    return;
  } 
  else 
  {
    const record = data && data.attributes;
    
    if (record !== null && record !== undefined) {
      switch (type) {
        case "create": 
          state.allData.data.unshift(record)
          break;
        case "delete":
          state.allData.data = state.allData.data.filter((item) => item.id !== record.id)
          break;
        default:
        {
          const updatedIndex = state.allData.data.findIndex((item) => item.id === record.id)
          if (updatedIndex !== -1) {
            state.allData.data[updatedIndex] = record
          }

          state.recordData = record;
          break;
        }
      }
    }

    if (message && !silent) {
      toast.success(message);
    }
  }
};

const setNestedPageHelper = (state, action) => {
  const { key, page } = action.payload;
  if (state[key]) {
    state[key].currentPage = page;
  }
};

const setNestedPageSizeHelper = (state, action) => {
  const { key, pageSize } = action.payload;
  if (state[key]) {
    state[key].pageSize = parseInt(pageSize);
  }
};

const setNestedParamsHelper = (state, action) => {
  const { key, params } = action.payload;
  if (state[key]) {
    state[key].currentParams = params;
  }
};

const resetNestedParamsHelper = (state, action) => {
  const { key } = action.payload;
  if (!state[key]) return;
  
  state[key].currentParams = { page: 1, per_page: PERPAGE_DEFAULT_SM };
  state[key].filterTags = [];
};

const setSortParamsHelper = (state, action) => {
  state.sortParams = action.payload;
};

const setFilterTagHelper = (state, action) => {
  const { key, tags } = action.payload;
  if (state[key]) {
    state[key].filterTags = tags;
  }
};

const resetFilterTagHelper = (state, action) => {
  const { key } = action.payload;
  if (state[key]) {
    state[key].filterTags = [];
  }
};

const setSelectedRecordHelper = (state, action) => {
  const { key, selectedRecord } = action.payload;
  if (state[key]) {
    state[key].selectedRecord = selectedRecord;
  }
};

const resetSelectedRecordHelper = (state, action) => {
  const { key } = action.payload;
  if (state[key]) {
    state[key].selectedRecord = [];
  }
};

export {
  createInitialState,
  initialState,
  initialStateStatus,
  setNestedPageHelper,
  setNestedPageSizeHelper,
  setNestedParamsHelper,
  resetNestedParamsHelper,
  setSortParamsHelper,
  setFilterTagHelper,
  resetFilterTagHelper,
  setSelectedRecordHelper,
  resetSelectedRecordHelper,
  handleFulfilled,
  handlePayload
};
